var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0845",
    d: "M5 16.247v2.364c0 .218.171.389.389.389h2.364a.364.364 0 00.272-.117l8.492-8.484-2.916-2.916-8.484 8.484a.382.382 0 00-.117.28zm13.773-8.103a.776.776 0 000-1.097l-1.82-1.82a.779.779 0 00-1.097 0l-1.423 1.424 2.916 2.916 1.424-1.423z"
  })));
}
export default SvgEdit;